import { Reveal, StagePill } from "./primitives";

/** Shared hero for interior pages. */
export const PageHero = ({ eyebrow, title, intro, image, imageAlt, children, testId = "page-hero" }) => (
  <section data-testid={testId} className="relative overflow-hidden bg-mint">
    <div className="dot-grid absolute inset-0 opacity-60" aria-hidden="true" />
    <div className="container-x relative grid items-center gap-12 py-16 lg:grid-cols-12 lg:py-24">
      <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
        <Reveal>
          <StagePill />
          {eyebrow && <p className="eyebrow mt-8">{eyebrow}</p>}
          <h1 className="mt-4 text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">{title}</h1>
          {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate md:text-lg">{intro}</p>}
          {children && <div className="mt-9 flex flex-wrap gap-3">{children}</div>}
        </Reveal>
      </div>
      {image && (
        <Reveal delay={0.15} className="lg:col-span-5">
          <figure className="relative">
            <img src={image} alt={imageAlt} className="aspect-[4/5] w-full rounded-[1.75rem] object-cover shadow-[0_30px_60px_-30px_rgba(44,15,101,0.45)] sm:aspect-[5/4] lg:aspect-[4/5]" loading="eager" data-testid={`${testId}-image`} />
            <figcaption className="mt-3 text-xs text-slate">Illustrative image. SwastSaathi does not yet operate centres.</figcaption>
          </figure>
        </Reveal>
      )}
    </div>
  </section>
);
